const tourSteps = [
    {
      selector: '[data-testid="general-filters-panel"]',
      content: `Это панель общих фильтров, где вы можете выбрать категорию, подкатегорию для фильтрации по ним искомых позиций, 
      и бренд для фильтрации по нему вариантов продуктов. Наш ИИ умеет распознать артикул продукции, если он присутствует в поисковом запросе
      поэтому фильтрация по бренду особенно полезна для задач переподбора аналогов другого бренда или если вам нужно подобрать продукцию определенного бренда`,
    },
    {
      selector: '[data-testid="edit-recherche-button"]',
      content: `Эта кнопка позволяет редактировать искомый запрос и запускать перепоиск продуктов.
      Если поисковый запрос содержит мало информации вы можете дополнить или изменить его чтоб ИИ мог более точно определить категорию и характеристики искомой позиции.`, 
    },
    {
      selector: '[data-testid="research-button"]',
      content: `Эта кнопка запускает перепоиск продуктов с дополнительным определением категории и характеристик из искомого запроса.
      В случае неудовлетворительного базового первоначального поиска воспользуйтесь этой опцией.`, 
    },
    {
      selector: '[data-testid="web-scrapper-button"]',
      content: `Эта опция позволяет запустить поиск артикула в интернете.
      Если поиск производился при первичном анализе заявки, то здесь вы увидите результаты веб поиска.`, 
    },
    {
      selector: '[data-testid="select-by-article-button"]',
      content: 'Если вам уже известен артикул для данного поискового запроса, нажмите эту ссылку, чтобы выбрать продукт по артикулу.',
    },
    {
      selector: `[data-testid="product-variants-filters-panel"]`,
      content: `Здесь вы можете изменять, добавлять и удалять фильтры по характеристикам и видам фильтрации для вариантов продукта.
      Если после применения фильтров в начале выдачи нет очевидно подходящих вариантов, попробуйте изменить приоритет сортировки, 
      чтобы в начале списка отобразились варианты с максимальным количеством примененных фильтров
      или изменить режим поиска, выбрав режим "без характеристик", в этом случае фильтры по характеристикам не будут применятся
      и отбор будет производится по схожести текста поискового запроса и описания продукта из каталога в рамках подкатегории, либо "Без фильтров" по всем категориям.`,
    },
    {
      selector: '[data-testid="select-variant-button"]', // 
      content: `Используйте эту кнопку, чтобы выбрать данный вариант продукта. 
      При выборе определенного варианта продукта поисковая выдача сузится до продкутов того же класса и характеристики будут взяты из этого варианта подбора`,
    },
    {
      selector: '[data-testid="details-button"]',
      content: 'Нажмите эту кнопку, чтобы просмотреть подробную информацию о продукте.',
    }
  ];


  export default tourSteps;